const renderFullPath = parts => {
    return '/' + parts.join('/');
};

export const SUPPORT_EMAIL = 'support@lexisnexisrisk.com';

export const FORGOTTEN_PASSWORD = 'forgotten-password';
export const OAUTH2_REDIRECT = 'oauth2';

export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const HOME = 'home';
export const PROFILE = 'profile';
export const APPLICATION = 'application';

export const LOGIN_URL = renderFullPath([LOGIN]);
export const LOGOUT_URL = renderFullPath([LOGOUT]);
export const HOME_URL = renderFullPath([HOME]);
export const PROFILE_URL = renderFullPath([PROFILE]);
export const APPLICATION_URL = renderFullPath([APPLICATION]);

export const FORGOTTEN_PASSWORD_URL = renderFullPath([LOGIN, FORGOTTEN_PASSWORD]);

export const OAUTH2_REDIRECT_URL = renderFullPath([LOGIN, OAUTH2_REDIRECT]);

export const renderApplicationPath = application => renderFullPath([APPLICATION, application]);